<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content">
       <!-- Фиксированный заголовок модального окна с поиском и кнопкой закрытия -->
      <div class="modal-header">
        <div class="search-input search-input_products">
          <input
            type="text"
            v-model="searchQuery"
            class="input-field clear-btn empty"
            @keydown.enter="onSearch"
            placeholder="Название, ID, артикул или штрих-код"
          />
          <button @click="onSearch" class="btn button button_secondary">Найти</button>
          <button @click="resetSearch" class="btn button button_reset">
            <span class="reset-icon">✕</span> Сбросить
          </button>
          <label class="checkbox-label">
            <input
              type="checkbox"
              v-model="inStockOnly"
              @change="onSearch"
              class="checkbox-input"
            />
            <span>В наличии</span>
          </label>
        </div>
        <button @click="closeModal" class="btn-close-modal"></button>
      </div>
      <div v-if="resultsFromMs" class="ms-fallback-hint">
        В каталоге сайта не найдено — показаны товары из МойСклад
      </div>
      
      <div class="filters-block">
        <!-- Быстрые фильтры -->
        <div class="quick-filters">
          <!-- Бренды -->
          <div class="quick-filter-section">
            <span class="quick-filter-title">Бренд:</span>
            <div class="quick-filter-chips">
              <button 
                v-for="brand in popularBrands" 
                :key="brand.id"
                @click="toggleQuickFilter('selectedBrands', brand.id)"
                :class="['quick-chip', { 'quick-chip-active': selectedBrands.includes(brand.id) }]"
              >
                {{ brand.label }}
              </button>
              <button 
                @click="expandFilter('brand')"
                class="quick-chip quick-chip-more"
                title="Другие бренды"
              >
                Другие
              </button>
            </div>
          </div>

          <!-- Тип корпуса -->
          <div class="quick-filter-section">
            <span class="quick-filter-title">Корпус:</span>
            <div class="quick-filter-chips">
              <button 
                v-for="corpus in popularCorpus" 
                :key="corpus.id"
                @click="toggleQuickFilter('selectedCorpus', corpus.id)"
                :class="['quick-chip', { 'quick-chip-active': selectedCorpus.includes(corpus.id) }]"
              >
                {{ corpus.label }}
              </button>
              <button 
                @click="expandFilter('corpus')"
                class="quick-chip quick-chip-more"
                title="Другие типы корпуса"
              >
                Другие
              </button>
            </div>
          </div>

          <!-- Ценовая категория -->
          <div class="quick-filter-section">
            <span class="quick-filter-title">Категория:</span>
            <div class="quick-filter-chips">
              <button 
                v-for="category in popularPriceCategories" 
                :key="category.id"
                @click="toggleQuickFilter('selectedPriceCategory', category.id)"
                :class="['quick-chip', { 'quick-chip-active': selectedPriceCategory.includes(category.id) }]"
              >
                {{ category.label }}
              </button>
              <button 
                @click="expandFilter('priceCategory')"
                class="quick-chip quick-chip-more"
                title="Другие категории"
              >
                Другие
              </button>
            </div>
          </div>

          <!-- Магазины -->
          <div class="quick-filter-section">
            <span class="quick-filter-title">Магазины:</span>
            <div class="quick-filter-chips">
              <button 
                v-for="store in popularStores" 
                :key="store.id"
                @click="toggleQuickFilter('selectedStores', store.id)"
                :class="['quick-chip', { 'quick-chip-active': selectedStores.includes(store.id) }]"
              >
                {{ store.label }}
              </button>
              <button 
                @click="expandFilter('stores')"
                class="quick-chip quick-chip-more"
                title="Другие магазины"
              >
                Другие
              </button>
            </div>
          </div>
        </div>

        <!-- Развернутые фильтры (селекты) -->
        <div v-if="expandedFilters.brand || expandedFilters.corpus || expandedFilters.priceCategory || expandedFilters.stores" class="expanded-filters">
          <div v-if="expandedFilters.brand" class="filter-group">
            <label class="filter-label">Все бренды:</label>
            <Treeselect
              :multiple="true"
              :options="brandFilters"
              placeholder="Выберите бренд"
              v-model="selectedBrands"
              @input="onSearch"
              class="filter-select"
            />
          </div>
          
          <div v-if="expandedFilters.corpus" class="filter-group">
            <label class="filter-label">Все типы корпуса:</label>
            <Treeselect
              :multiple="true"
              :options="corpusFilters"
              placeholder="Выберите тип корпуса"
              v-model="selectedCorpus"
              @input="onSearch"
              class="filter-select"
            />
          </div>
          
          <div v-if="expandedFilters.priceCategory" class="filter-group">
            <label class="filter-label">Все категории:</label>
            <Treeselect
              :multiple="true"
              :options="priceCategoryFilters"
              placeholder="Выберите категорию"
              v-model="selectedPriceCategory"
              @input="onSearch"
              class="filter-select"
            />
          </div>
          
          <div v-if="expandedFilters.stores" class="filter-group">
            <label class="filter-label">Все магазины:</label>
            <Treeselect
              :multiple="true"
              :options="storeFilters"
              placeholder="Выберите магазин"
              v-model="selectedStores"
              @input="onSearch"
              class="filter-select"
            />
          </div>
        </div>
      </div>
      <div v-if="localLoading" class="loader-container">
        <div class="spinner"></div>
      </div>
      <div v-else class="product-list">
       

          <table ref="productTable" class="modern-table list js-order-list batch-tbl">
          <thead>
            <tr>
              <th>Фото</th>
              <th @click="sort('residues')" class="sortable">
                Наименование
                <span :class="['sort-arrow', currentSort === 'residues' ? 'sort-arrow-active' : 'sort-arrow-inactive']">
                  {{ currentSort === 'residues' ? (currentSortDir === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
       
              <th @click="sort('tok')" class="sortable">
                Пуск. ток
                <span :class="['sort-arrow', currentSort === 'tok' ? 'sort-arrow-active' : 'sort-arrow-inactive']">
                  {{ currentSort === 'tok' ? (currentSortDir === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
              <th @click="sort('emkost')" class="sortable">
                Емкость
                <span :class="['sort-arrow', currentSort === 'emkost' ? 'sort-arrow-active' : 'sort-arrow-inactive']">
                  {{ currentSort === 'emkost' ? (currentSortDir === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
              <th>Дата выпуска</th>
             
              <th>Наличие у нас</th>
              <th>Наличие у поставщиков</th>
              <th @click="sort('price')" class="sortable">
                Цена (руб.)
                <span :class="['sort-arrow', currentSort === 'price' ? 'sort-arrow-active' : 'sort-arrow-inactive']">
                  {{ currentSort === 'price' ? (currentSortDir === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
              <th @click="sort('seba')" class="sortable">
                Бонус
                <span :class="['sort-arrow', currentSort === 'seba' ? 'sort-arrow-active' : 'sort-arrow-inactive']">
                  {{ currentSort === 'seba' ? (currentSortDir === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
             
              <th>Количество</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="product in displayedProducts"
              :key="product.id"
              :class="{ 'in-order': isProductInOrder(product.id) }"
            >
              <td style="max-width:50px"><img :src="product.jpg_url" alt="Фото товара" style="max-width:50px"/></td>
              <td @click="emitAddProduct(product)" style="position:relative;">
                <a :href="product.href" target="_blank">{{ product.name }}</a><span>{{ product.artikul }}</span>
                <div class="property">
                  <span v-if="product.korpus" class="property-value">{{ product.korpus }}</span>
                  <span v-if="product.korpus && (product.length || product.width || product.height || product.polarka || product.countday)" class="property-separator">; </span>
                  <span v-if="product.length || product.width || product.height" class="property-value">
                    {{ [product.length, product.width, product.height].filter(v => v).join('*') }}
                  </span>
                  <span v-if="(product.length || product.width || product.height) && (product.polarka || product.countday)" class="property-separator">; </span>
                  <span v-if="product.polarka" class="property-value">{{ product.polarka }}</span>
                  <span v-if="product.polarka && product.countday" class="property-separator">; </span>
                  <span v-if="product.countday" class="property-value">{{ product.countday }} мес.</span> 
                  <div 
                    :class="[
                      'count',
                      { 'count-low': product.count < 10 },
                      { 'count-medium': product.count >= 10 && product.count <= 30 },
                      { 'count-high': product.count > 30 }
                    ]"
                  >
                    {{ product.count }} шт
                  </div>
                </div>
                <span v-if="isProductInOrder(product.id)" class="in-order-label">В заказе</span>
              </td>
   
              <td>{{ product.starttok }}</td>
              <td>{{ product.emkost }}</td>
              <td class="gtd-cell">
                <span v-if="product.gtd" class="gtd-value" :title="product.gtd">{{ product.gtd }}</span>
                <span v-else class="gtd-empty">—</span>
              </td>
              
              <!-- Вывод складов с группировкой (как на странице товаров) -->
              <td style="min-width: 85px;">
                <div style="display:flex;flex-wrap: wrap;">
                  <!-- Если фильтруем по магазинам - показываем отдельные магазины -->
                  <template v-if="selectedStores.length > 0">
                    <p v-for="m in filteredSkladm(product)" :key="m.id" class="tooltips_blue">
                      <span
                        :class="[
                          { 'blue-text': isBlueId(m.id) },
                          { 'green-karvata': isKarvata(m.id) },
                          'warehouse-item'
                        ]"
                      >
                        {{ formatStoreLabel(m) }}
                      </span>
                    </p>
                  </template>
                  <!-- Если не фильтруем - показываем с группировкой -->
                  <template v-else>
                    <!-- Карвата первым -->
                    <template v-if="getStoreEntry(product, 'Карвата')">
                      <p class="tooltips_blue">
                        <span class="warehouse-item green-karvata">
                          {{ formatStoreLabel(getStoreEntry(product, 'Карвата')) }}
                        </span>
                      </p>
                    </template>

                    <!-- Группы Минск и Регионы -->
                    <template v-for="groupKey in ['minsk', 'regions']">
                      <template v-if="hasGroupData(product, groupKey)">
                        <p 
                          v-if="!isGroupExpanded(product.id, groupKey)"
                          class="tooltips_blue" 
                          :key="`group-${product.id}-${groupKey}`"
                        >
                          <span
                            class="warehouse-item warehouse-group-toggle"
                            :class="{ 'blue-text': groupKey === 'minsk' }"
                            @click.stop="toggleWarehouseGroup(product.id, groupKey)"
                          >
                            {{ getGroupLabel(product, groupKey) }}
                          </span>
                        </p>
                        <div
                          v-if="isGroupExpanded(product.id, groupKey)"
                          class="warehouse-group-details"
                          :key="`details-${product.id}-${groupKey}`"
                        >
                          <p
                            v-for="store in getGroupStores(product, groupKey)"
                            :key="`expanded-${product.id}-${groupKey}-${store.id}`"
                            class="tooltips_blue"
                          >
                            <span
                              :class="[
                                { 'blue-text': isBlueId(store.id) },
                                { 'green-karvata': isKarvata(store.id) },
                                'warehouse-item'
                              ]"
                            >
                              {{ formatStoreLabel(store) }}
                            </span>
                          </p>
                        </div>
                      </template>
                    </template>

                    <!-- Остальные магазины -->
                    <p
                      v-for="(m, mIndex) in getRemainingStores(product)"
                      :key="`m-${product.id}-other-${mIndex}`"
                      class="tooltips_blue"
                    >
                      <span
                        :class="[
                          { 'blue-text': isBlueId(m.id) },
                          { 'green-karvata': isKarvata(m.id) },
                          'warehouse-item'
                        ]"
                      >
                        {{ formatStoreLabel(m) }}
                      </span>
                    </p>
                  </template>
                </div>
              </td>
              <td>
                <p v-for="p in filteredSkladp(product)" :key="p.id">
                  <span class="warehouse-item">
                    {{ p.id }}-<span>{{ p.count }}</span>
                  </span>
                </p>
              </td>

              
              <td>
                <div class="price-cell">
                  <span v-if="product.old_price" class="old-price">{{ product.old_price }} руб.</span>
                  <span class="price-current">{{ product.price }} руб.</span>
                </div>
              </td>
              <td >{{ product.seba }}</td>
              
             <td>
                <div class="button_quantity" v-if="isProductInOrder(product.id)">
                <button v-if="isProductInOrder(product.id)" @click.stop="decreaseQuantity(product)" class="qty-btn qty-btn-decrease">-</button>
                <span v-if="isProductInOrder(product.id)" class="quantity">{{ getQuantity(product) }}</span>
                <button v-if="isProductInOrder(product.id)" @click.stop="increaseQuantity(product)" class="qty-btn qty-btn-increase">+</button>
                </div>
                <button v-else @click="emitAddProduct(product)" class="add-btn">Добавить</button>
              </td>
            </tr>
          </tbody>
        </table>

        <button v-if="hasMoreProducts" @click="loadMore" class="load-more-btn" :disabled="isLoadingMore">
          <span v-if="isLoadingMore" class="spinner"></span>
          <span>Показать еще</span>
        </button>
      </div>
      
    </div>
  </div>
</template>

<script>
import { ORDERS_API_BASE } from '@/config/api';
import axios from 'axios';
import { Treeselect } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: {
    Treeselect,
  },
  props: {
    products: Array,
    isProductInOrder: Function,
    isVisible: Boolean,
    loading: Boolean,
    initialCorpusTypes: {
      type: Array,
      default: () => [],
    },
    initialSearchQuery: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchQuery: '',
      displayedProducts: [],
      itemsPerPage: 30,
      currentPage: 1,
      totalItems: 0,
      currentSort: 'seba',
      currentSortDir: 'desc',
      isLoadingMore: false,
      localLoading: this.loading,
      inStockOnly: true,
      resultsFromMs: false,
      selectedBrands: [],
      selectedCorpus: [],
      selectedPriceCategory: [],
      selectedStores: [],
      expandedFilters: {
        brand: false,
        corpus: false,
        priceCategory: false,
        stores: false,
      },
      warehouseGroupState: {},
      warehouseDisplayGroups: {
        minsk: {
          label: 'Минск',
          stores: ['Володько', 'Машинка', 'Салюты', 'Бельского']
        },
        regions: {
          label: 'Регионы',
          stores: ['Гомель-Ефрем', 'Гомель-Бакун', 'Брест', 'Витебск', 'Полоцк', 'Могилев', 'Барановичи', 'Гродно', 'Новополоцк', 'Бобруйск']
        }
      },
      // Популярные значения для быстрых фильтров
      popularBrands: [
        { id: 'Ultra Pro', label: 'Ultra Pro' },
        { id: 'Tubor', label: 'Tubor' },
        { id: 'АКОМ', label: 'АКОМ' },
        { id: 'Tudor', label: 'Tudor' },
        { id: 'ENERGY PREMIUM', label: 'ENERGY PREMIUM' },
        { id: 'Sonic', label: 'Sonic' },
      ],
      popularCorpus: [
        { id: 'L2', label: 'L2' },
        { id: 'L3', label: 'L3' },
        { id: 'L4', label: 'L4' },
        { id: 'L5', label: 'L5' },
        { id: 'LB2', label: 'LB2' },
        { id: 'LB3', label: 'LB3' },
        { id: 'LB4', label: 'LB4' },
      ],
      popularPriceCategories: [
        { id: 'AGM', label: 'AGM' },
        { id: 'EFB', label: 'EFB' },
      ],
      popularStores: [
        { id: 'Володько', label: 'Володько' },
        { id: 'Машинка', label: 'Машинка' },
        { id: 'Салюты', label: 'Салюты' },
        { id: 'Бельского', label: 'Бельского' },
        { id: 'Карвата', label: 'Карвата' },
        { id: 'Гомель-Ефрем', label: 'Гомель-Ефрем' },
        { id: 'Гомель-Бакун', label: 'Гомель-Бакун' },
        { id: 'Брест', label: 'Брест' },
        { id: 'Витебск', label: 'Витебск' },
        { id: 'Полоцк', label: 'Полоцк' },
        { id: 'Могилев', label: 'Могилев' },
        { id: 'Барановичи', label: 'Барановичи' },
        { id: 'Бобруйск', label: 'Бобруйск' },
        { id: 'Гродно', label: 'Гродно' },
        { id: 'Новополоцк', label: 'Новополоцк' },
      ],
      // Все значения из API для селекта "Другие"
      brandFilters: [],
      corpusFilters: [ {
          id: 'auto',
          label: 'Европейские типы корпусов',
          children: [ {
            id: 'L0',
            label: "L0 - (175x175x190)",
          }, {
            id: "L1",
            label: "L1 - (207x175x190)",
          }, {
            id: "L2",
            label: "L2 - (242x175x190)",
          }, {
            id: "L3",
            label: "L3 - (278x175x190)",
          }, {
            id: "L4",
            label: "L4 - (315x175x190)",
          }, {
            id: "L5",
            label: "L5 - (353x175x190)",
          }, {
            id: "L6", 
            label: "L6 - (393x175x190)", 
          }, {
            id: "LB1", 
            label: "LB1 - (207x175x175)", 
          }, {
            id: "LB2",
            label: "LB2 - (242x175x175)",
            }, {
            id: "LB3",
            label: "LB3 - (278x175x175)",
            }, {
            id: "LB4",
            label: "LB4 - (315x175x175)",
            }, {
            id: "LB5",
            label: "LB5 - (353x175x175)",
            }, {
            id: "LB1L",
            label: "LB1L - (207x175x175)",
            }, {
            id: "LB2L",
            label: "LB2L - (242x175x175)",
            }, {
            id: "LB3L",
            label: "LB3L - (278x175x175)",
            }, {
            id: "LB4L",
            label: "LB4L - (315x175x175)",
            }, {
            id: "LB5L",
            label: "LB5L - (353x175x175)",
            }, {
            id: "L0L",
            label: "L0L - (175x175x190)",
            }, {
            id: "L1L",
            label: "L1L - (207x175x190)",
            }, {
            id: "L2L",
            label: "L2L - (242x175x190)",
            }, {
            id: "L3L",
            label: "L3L - (278x175x190)",
            }, {
            id: "L4L",
            label: "L4L - (315x175x190)",
            }, {
            id: "L5L",
            label: "L5L - (353x175x175)",
        } ],
      }, {
          id: 'aziat',
          label: 'Азиатские типы корпусов',
          children: [ {
            id: "D23",
            label: "D23 - (230x175x225)",
          }, {
            id: "D23L",
            label: "D23L - (230x175x225)",
          }, {
            id: "D26",
            label: "D26 - (260x175x225)",
          }, {
            id: "D26L",
            label: "D26L - (260x175x225)",
          }, {
            id: "D31",
            label: "D31 - (306x175x225)",
          }, {
            id: "D31L",
            label: "D31L - (306x175x225)",
          }, {
            id: "B19",
            label: "B19 - (187х127х225)",
          }, {
            id: "B19L",
            label: "B19L - (187х127х225)",
          }, {
            id: "B24",
            label: "B24 - (238x127x225)",
          }, {
            id: "B24L",
            label: "B24L - (238x127x225)",
          } ],
      },{
          id: 'gruz',
          label: 'Для Грузовых',
          children: [ {
            id: "D2",
            label: "D2 - (349x175x235)",
          }, {
            id: "D3",
            label: "D3 - (345x173x284)",
          }, {
            id: "D4",
            label: "D4 - (513x189x223)",
          }, {
            id: "D5",
            label: "D5 - (513x223x220)",
          }, {
            id: "D6",
            label: "D6 - (518x276x240)",
          } ],
      },{
          "id": "moto",
          "label": "Мотоциклетные",
          "children": [
            {
              "id": "YTX4L-BS",
              "label": "YTX4L-BS"
            },
            {
              "id": "YB9-B",
              "label": "YB9-B"
            },
            {
              "id": "YTX24HL",
              "label": "YTX24HL"
            },
            {
              "id": "YTX12-BS",
              "label": "YTX12-BS"
            },
            {
              "id": "YB14L-A2",
              "label": "YB14L-A2"
            },
            {
              "id": "YT19BL-BS",
              "label": "YT19BL-BS"
            },
            {
              "id": "YTX16-BS",
              "label": "YTX16-BS"
            },
            {
              "id": "53030",
              "label": "53030"
            },
            {
              "id": "YB14-A2",
              "label": "YB14-A2"
            },
            {
              "id": "YB12A-A",
              "label": "YB12A-A"
            },
            {
              "id": "YT12B-BS",
              "label": "YT12B-BS"
            },
            {
              "id": "YB10L-B2",
              "label": "YB10L-B2"
            },
            {
              "id": "YTZ14S",
              "label": "YTZ14S"
            },
            {
              "id": "YTX7L-BS",
              "label": "YTX7L-BS"
            },
            {
              "id": "YB30L-B",
              "label": "YB30L-B"
            },
            {
              "id": "6N4-2A",
              "label": "6N4-2A"
            },
            {
              "id": "YB5L-B",
              "label": "YB5L-B"
            },
            {
              "id": "YTX20-BS",
              "label": "YTX20-BS"
            },
            {
              "id": "YTR4A-BS",
              "label": "YTR4A-BS"
            },
            {
              "id": "YT9B-BS",
              "label": "YT9B-BS"
            },
            {
              "id": "YT7B-BS",
              "label": "YT7B-BS"
            },
            {
              "id": "YB4L-B",
              "label": "YB4L-B"
            },
            {
              "id": "YB3L-A",
              "label": "YB3L-A"
            },
            {
              "id": "YB16B-A",
              "label": "YB16B-A"
            },
            {
              "id": "YB16AL-A2",
              "label": "YB16AL-A2"
            },
            {
              "id": "YB12AL-A",
              "label": "YB12AL-A"
            },
            {
              "id": "Y60-N24-A",
              "label": "Y60-N24-A"
            },
            {
              "id": "YTX14L-BS",
              "label": "YTX14L-BS"
            },
            {
              "id": "YT14B-BS",
              "label": "YT14B-BS"
            },
            {
              "id": "YB16CL-B",
              "label": "YB16CL-B"
            },
            {
              "id": "YB16-B",
              "label": "YB16-B"
            },
            {
              "id": "YB14A-A2",
              "label": "YB14A-A2"
            },
            {
              "id": "12N5.5-3B",
              "label": "12N5.5-3B"
            },
            {
              "id": "6N11A-1B",
              "label": "6N11A-1B"
            },
            {
              "id": "YB16L",
              "label": "YB16L"
            },
            {
              "id": "6N6-3B",
              "label": "6N6-3B"
            },
            {
              "id": "6N2-2A",
              "label": "6N2-2A"
            },
            {
              "id": "YB30CL-B",
              "label": "YB30CL-B"
            },
            {
              "id": "YB7C-A",
              "label": "YB7C-A"
            },
            {
              "id": "B49-6",
              "label": "B49-6"
            },
            {
              "id": "12N5.5A-3B",
              "label": "12N5.5A-3B"
            },
            {
              "id": "6N4B-2A",
              "label": "6N4B-2A"
            },
            {
              "id": "YTZ12S",
              "label": "YTZ12S"
            },
            {
              "id": "YTX15L-BS",
              "label": "YTX15L-BS"
            },
            {
              "id": "YB7B-B",
              "label": "YB7B-B"
            },
            {
              "id": "B38-6A",
              "label": "B38-6A"
            },
            {
              "id": "AGM12-7F",
              "label": "AGM12-7F"
            },
            {
              "id": "12N5-4B",
              "label": "12N5-4B"
            },
            {
              "id": "6N12A-2D",
              "label": "6N12A-2D"
            },
            {
              "id": "6N2A-2C",
              "label": "6N2A-2C"
            },
            {
              "id": "YTZ7S",
              "label": "YTZ7S"
            },
            {
              "id": "YTX24HL-BS",
              "label": "YTX24HL-BS"
            },
            {
              "id": "YT20L-4",
              "label": "YT20L-4"
            },
            {
              "id": "YIX30L-BS",
              "label": "YIX30L-BS"
            },
            {
              "id": "YB30L-BS",
              "label": "YB30L-BS"
            },
            {
              "id": "YB5L-BS",
              "label": "YB5L-BS"
            },
            {
              "id": "Tesla",
              "label": "Tesla"
            },
            {
              "id": "Добавить",
              "label": "Добавить"
            },
            {
              "id": "YTZ14S-BS",
              "label": "YTZ14S-BS"
            },
            {
              "id": "YTZ12S-BS",
              "label": "YTZ12S-BS"
            },
            {
              "id": "YTZ10S-BS",
              "label": "YTZ10S-BS"
            },
            {
              "id": "YTZ10S",
              "label": "YTZ10S"
            },
            {
              "id": "YTZ7S-BS",
              "label": "YTZ7S-BS"
            },
            {
              "id": "YTX20СH-BS",
              "label": "YTX20СH-BS"
            },
            {
              "id": "YTX20H-BS",
              "label": "YTX20H-BS"
            },
            {
              "id": "YTX20",
              "label": "YTX20"
            },
            {
              "id": "YTX4L-B",
              "label": "YTX4L-B"
            },
            {
              "id": "YT14B-4",
              "label": "YT14B-4"
            },
            {
              "id": "YT12A-BS",
              "label": "YT12A-BS"
            },
            {
              "id": "YT7B-4",
              "label": "YT7B-4"
            },
            {
              "id": "YB19L-BS",
              "label": "YB19L-BS"
            },
            {
              "id": "YB16L-BS",
              "label": "YB16L-BS"
            },
            {
              "id": "12N5-3B",
              "label": "12N5-3B"
            },
            {
              "id": "YTX7A-BS",
              "label": "YTX7A-BS"
            },
            {
              "id": "YTX9-BS",
              "label": "YTX9-BS"
            },
            {
              "id": "YTX20L-BS",
              "label": "YTX20L-BS"
            },
            {
              "id": "YTX5L-BS",
              "label": "YTX5L-BS"
            },
            {
              "id": "YTX14-BS",
              "label": "YTX14-BS"
            },
            {
              "id": "YB9L-A2",
              "label": "YB9L-A2"
            }
          ]
        }
      ],
      priceCategoryFilters: [],
      storeFilters: [
        { id: 'Володько', label: 'Володько' },
        { id: 'Машинка', label: 'Машинка' },
        { id: 'Салюты', label: 'Салюты' },
        { id: 'Бельского', label: 'Бельского' },
        { id: 'Карвата', label: 'Карвата' },
        { id: 'Гомель-Ефрем', label: 'Гомель-Ефрем' },
        { id: 'Гомель-Бакун', label: 'Гомель-Бакун' },
        { id: 'Брест', label: 'Брест' },
        { id: 'Витебск', label: 'Витебск' },
        { id: 'Полоцк', label: 'Полоцк' },
        { id: 'Могилев', label: 'Могилев' },
        { id: 'Барановичи', label: 'Барановичи' },
        { id: 'Бобруйск', label: 'Бобруйск' },
        { id: 'Гродно', label: 'Гродно' },
        { id: 'Новополоцк', label: 'Новополоцк' },
      ],
    };
  },
  computed: {
    hasMoreProducts() {
      return this.displayedProducts.length < this.totalItems;
    },
    filteredSkladm() {
      return (product) => {
        if (!product.skladm) return [];
        // Если выбраны магазины в фильтре, показываем только их
        if (this.selectedStores.length > 0) {
          return product.skladm.filter(m => this.selectedStores.includes(m.id) && (m.count > 0 || m.reserve > 0));
        }
        // Если фильтр не выбран, показываем все с наличием
        return product.skladm.filter(m => m.count > 0 || m.reserve > 0);
      };
    },
    filteredSkladp() {
      return (product) => {
        if (!product.skladp) return [];
        // Если выбраны магазины в фильтре, показываем только их
        if (this.selectedStores.length > 0) {
          return product.skladp.filter(p => this.selectedStores.includes(p.id) && p.count > 0);
        }
        // Если фильтр не выбран, показываем все с наличием
        return product.skladp.filter(p => p.count > 0);
      };
    },
  },
  methods: {
    // Загрузка брендов из API
    async fetchManufacturer() {
      try {
        const response = await axios.get(ORDERS_API_BASE + '/manufacturer.php');
        this.brandFilters = response.data.map(item => ({
          id: item.label,
          label: item.label
        }));
      } catch (error) {
        console.error('Ошибка при загрузке брендов:', error);
      }
    },

    // Загрузка типов корпуса из API

    // Загрузка ценовых категорий из API
    async fetchPriceCategories() {
      try {
        const response = await axios.get(ORDERS_API_BASE + '/pricecategory.php');
        this.priceCategoryFilters = response.data.map(item => ({
          id: item.label,
          label: item.label
        }));
      } catch (error) {
        console.error('Ошибка при загрузке ценовых категорий:', error);
      }
    },

    // Переключение быстрого фильтра
    toggleQuickFilter(filterName, value) {
      const currentValue = this[filterName];
      const index = currentValue.indexOf(value);
      
      if (index > -1) {
        // Убираем значение
        this[filterName] = currentValue.filter(v => v !== value);
      } else {
        // Добавляем значение
        this[filterName] = [...currentValue, value];
      }
      
      this.onSearch();
    },
    
    // Раскрытие полного списка фильтров
    expandFilter(filterType) {
      this.expandedFilters[filterType] = !this.expandedFilters[filterType];
    },
    
    isBlueId(id) {
      return ['Володько', 'Машинка', 'Салюты', 'Бельского'].includes(id);
    },
    isKarvata(id) {
      return ['Карвата'].includes(id);
    },
    formatStoreLabel(store) {
      if (!store) return '';
      const reserve = Number(store.reserve);
      const reserveText = !isNaN(reserve) && reserve > 0 ? ` (${reserve})` : '';
      return `${store.id} - ${store.count || 0}${reserveText} шт.`;
    },
    getStoreEntry(product, storeId) {
      if (!product || !storeId) return null;
      const stores = this.filteredSkladm(product);
      if (!stores || !Array.isArray(stores)) return null;
      return stores.find(store => store && store.id === storeId && (store.count > 0 || store.reserve > 0)) || null;
    },
    getGroupTotals(product, groupKey) {
      if (!product || !groupKey) return { count: 0, reserve: 0 };
      const group = (this.warehouseDisplayGroups && this.warehouseDisplayGroups[groupKey]) || null;
      if (!group || !group.stores) return { count: 0, reserve: 0 };
      const stores = this.filteredSkladm(product);
      if (!stores || !Array.isArray(stores)) return { count: 0, reserve: 0 };
      return stores.reduce(
        (acc, store) => {
          if (store && group.stores.includes(store.id)) {
            const count = Number(store.count) || 0;
            const reserve = Number(store.reserve) || 0;
            acc.count += count;
            if (!isNaN(reserve) && reserve > 0) {
              acc.reserve += reserve;
            }
          }
          return acc;
        },
        { count: 0, reserve: 0 }
      );
    },
    hasGroupData(product, groupKey) {
      const totals = this.getGroupTotals(product, groupKey);
      return totals.count > 0;
    },
    getGroupLabel(product, groupKey) {
      if (!product || !groupKey) return '';
      const group = (this.warehouseDisplayGroups && this.warehouseDisplayGroups[groupKey]) || null;
      if (!group || !group.label) return '';
      const totals = this.getGroupTotals(product, groupKey);
      if (!totals) return '';
      const reserveText = totals.reserve > 0 ? ` (${totals.reserve})` : '';
      return `${group.label} - ${totals.count}${reserveText} шт...`;
    },
    toggleWarehouseGroup(productId, groupKey) {
      if (!this.warehouseGroupState[productId]) {
        this.$set(this.warehouseGroupState, productId, {});
      }
      const currentState = this.warehouseGroupState[productId][groupKey] || false;
      this.$set(this.warehouseGroupState[productId], groupKey, !currentState);
    },
    isGroupExpanded(productId, groupKey) {
      return !!(this.warehouseGroupState[productId] && this.warehouseGroupState[productId][groupKey]);
    },
    getGroupStores(product, groupKey) {
      if (!product || !groupKey) return [];
      const group = (this.warehouseDisplayGroups && this.warehouseDisplayGroups[groupKey]) || null;
      if (!group || !group.stores) return [];
      const stores = this.filteredSkladm(product);
      if (!stores || !Array.isArray(stores)) return [];
      return stores.filter(store => store && group.stores.includes(store.id));
    },
    getRemainingStores(product) {
      const stores = this.filteredSkladm(product);
      if (!stores || !Array.isArray(stores)) return [];
      const minskStores = (this.warehouseDisplayGroups && this.warehouseDisplayGroups.minsk && this.warehouseDisplayGroups.minsk.stores) || [];
      const regionsStores = (this.warehouseDisplayGroups && this.warehouseDisplayGroups.regions && this.warehouseDisplayGroups.regions.stores) || [];
      const excluded = new Set([
        'Карвата',
        ...minskStores,
        ...regionsStores
      ]);
      return stores.filter(store => store && !excluded.has(store.id));
    },
    sort(field) {
      // Меняем направление сортировки, если поле уже выбрано
      if (field === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSort = field;
        this.currentSortDir = 'asc';
      }

      // Сбрасываем страницу на первую при смене сортировки
      this.currentPage = 1;
      this.displayedProducts = [];
      this.fetchProducts(); // Перезагружаем данные с новыми параметрами сортировки
    },
    getQuantity(product) {
      const selectedProduct = this.products.find(p => p.id === product.id);
      return selectedProduct ? selectedProduct.quantity : 1;
    },
    emitAddProduct(product) {
      if (this.isProductInOrder(product.id)) {
      // Если товар уже добавлен, удаляем его
      this.$emit('remove-product', product.id);
      } else {
        // Если товар не добавлен, добавляем его
        this.$emit('add-product', product);
      }
    },

    increaseQuantity(product) {
      this.$emit('increase-product', product.id);
    },
    decreaseQuantity(product) {
      this.$emit('decrease-product', product.id);
    },
    closeModal() {
      this.$emit('close');
    },
    onSearch() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    resetSearch() {
      this.searchQuery = '';
      this.selectedBrands = [];
      this.selectedCorpus = [];
      this.selectedPriceCategory = [];
      this.selectedStores = [];
      this.resultsFromMs = false;
      this.expandedFilters = {
        brand: false,
        corpus: false,
        priceCategory: false,
        stores: false,
      };
      this.onSearch();
    },
    loadMore() {
      this.currentPage++;
      this.fetchProducts();
    },
    async fetchProductsFromMs() {
      const q = (this.searchQuery || '').trim();
      if (!q) {
        return { items: [], totalItems: 0 };
      }
      const response = await axios.get(ORDERS_API_BASE + '/msproduct.php', {
        params: {
          search: q,
          limit: this.itemsPerPage,
          offset: (this.currentPage - 1) * this.itemsPerPage,
          onlyAvailable: this.inStockOnly ? 1 : 0,
        },
      });
      const items = (response.data && response.data.items) || [];
      const totalItems = (response.data && (response.data.totalItems || response.data.total)) || items.length;
      return { items, totalItems };
    },
    async fetchProducts() {
      this.localLoading = this.currentPage === 1;
      this.isLoadingMore = this.currentPage > 1;
      if (this.currentPage === 1) {
        this.resultsFromMs = false;
      }

      // Формируем параметры запроса
      const params = new URLSearchParams();
      params.append('query', this.searchQuery);
      params.append('page', this.currentPage);
      params.append('sortField', this.currentSort);
      params.append('sortDirection', this.currentSortDir);
      params.append('inStockOnly', this.inStockOnly ? 1 : 0);
      
      // Добавляем массивы для фильтров
      if (this.selectedBrands.length > 0) {
        this.selectedBrands.forEach(brand => {
          params.append('brends[]', brand);
        });
      }
      
      if (this.selectedCorpus.length > 0) {
        this.selectedCorpus.forEach(corpus => {
          params.append('corpus[]', corpus);
        });
      }
      
      if (this.selectedPriceCategory.length > 0) {
        this.selectedPriceCategory.forEach(category => {
          params.append('pricekat[]', category);
        });
      }
      
      if (this.selectedStores.length > 0) {
        this.selectedStores.forEach(store => {
          params.append('stores[]', store);
        });
      }

      try {
        const response = await axios.get(ORDERS_API_BASE + '/modalproduct.php?' + params.toString());
        let items = (response.data && response.data.items) || [];
        let totalItems = (response.data && (response.data.totalItems != null ? response.data.totalItems : response.data.total)) || 0;
        let fromMs = false;

        // Если в Bitrix ничего нет по поисковому запросу — ищем в МойСклад
        const hasQuery = (this.searchQuery || '').trim().length > 0;
        if (hasQuery && this.currentPage === 1 && (!items || items.length === 0)) {
          try {
            const ms = await this.fetchProductsFromMs();
            if (ms.items && ms.items.length > 0) {
              items = ms.items;
              totalItems = ms.totalItems;
              fromMs = true;
            }
          } catch (msErr) {
            console.error('Ошибка поиска в МойСклад:', msErr);
          }
        }

        if (this.currentPage === 1) {
          this.displayedProducts = items;
          this.resultsFromMs = fromMs;
        } else {
          this.displayedProducts = [...this.displayedProducts, ...items];
        }

        this.totalItems = totalItems;
        this.scrollToNewItems();
      } catch (error) {
        console.error('Ошибка при загрузке товаров:', error);
        // На ошибке Bitrix тоже пробуем МойСклад по запросу
        const hasQuery = (this.searchQuery || '').trim().length > 0;
        if (hasQuery && this.currentPage === 1) {
          try {
            const ms = await this.fetchProductsFromMs();
            this.displayedProducts = ms.items || [];
            this.totalItems = ms.totalItems || 0;
            this.resultsFromMs = (ms.items || []).length > 0;
          } catch (msErr) {
            console.error('Ошибка поиска в МойСклад:', msErr);
          }
        }
      } finally {
        this.localLoading = false;
        this.isLoadingMore = false;
      }
    },
    scrollToNewItems() {
  this.$nextTick(() => {
    const table = this.$refs.productTable;

    if (table) {
      // Рассчитываем смещение вверх для отображения новых подгруженных элементов
      const firstRow = table.querySelector('tbody tr');
      const rowHeight = firstRow ? firstRow.offsetHeight : 0;
      const rowsToScroll = this.itemsPerPage; // Смещение на количество новых строк
      const scrollOffset = rowHeight * rowsToScroll;

      // Прокручиваем видимость только на высоту подгруженных строк
      table.scrollTop = table.scrollTop + scrollOffset;
    }
  });
}
,
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        if (this.initialCorpusTypes && this.initialCorpusTypes.length) {
          this.selectedCorpus = [...this.initialCorpusTypes];
        }
        if (this.initialSearchQuery) {
          this.searchQuery = this.initialSearchQuery;
        }
        this.currentPage = 1;
        this.fetchProducts();
      }
    },
    loading(newVal) {
      this.localLoading = newVal;
    }
  },
  mounted() {
    // Загружаем фильтры при монтировании компонента
    this.fetchManufacturer();
    this.fetchPriceCategories();
  },
};
</script>

<style scoped>
button:not(:disabled), [type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled) {
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
}
.gtd-cell {
  max-width: 120px;
  font-size: 12px;
  word-break: break-word;
  text-align: center;
}
.gtd-value {
  color: #1a4a7a;
  font-weight: 600;
}
.gtd-empty {
  color: #adb5bd;
}
.qty-btn {
  margin: 0 4px;
}
.in-order {
  background-color: #f0f8ff;
}
.in-order-label {
  color: #ff4500;
  font-weight: bold;
  margin-left: 4px;
}
.ms-fallback-hint {
  background: #fff8e6;
  color: #7a5a00;
  font-size: 12px;
  line-height: 1.3;
  padding: 6px 12px;
  border-bottom: 1px solid #f0e0a8;
}
.add-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.modal-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  
}


.modal-content {
    background: white;
    padding: 0px;
    border-radius: 5px;
    max-width: 80%;
    max-height: 80%;
    overflow-y: auto;
    position: relative;
    right: 0;
    left: 0;
    z-index: 1040;
    --default-padding: 56px 296px;
    max-width: 1192px;
    width: 100%;
    height: 100%;
    margin: 40px auto;
    border-radius: 0px;
    background: #fafafa;
    max-height: calc(100vh - 80px);
    overflow: hidden;
    margin: 60px auto 40px auto;
    overflow-y: scroll;
    position: relative;
}

.modal-content {
    background: #ffffff;
    width: 100%;
    max-width: 1340px;
    position: relative;
    overflow-y: auto;
    max-height: 95vh;
}


/* Фиксированный заголовок с поиском и кнопкой закрытия */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.search-input_products {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.filters-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  background-color: #f9fafb;
  border-top: 1px solid #dee2e6;
}



/* Развернутые фильтры */
.expanded-filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding-top: 6px;
  border-top: 1px dashed #dee2e6;
  margin-top: 4px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-label {
  font-size: 13px;
  white-space: nowrap;
  color: #333;
}

.filter-select {
  min-width: 150px;
  max-width: 200px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  color: #333;
}

.checkbox-input {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #ff5353;
}

table.modern-table {
  width: 100%;
  border-collapse: collapse;
}

/* Фиксированные заголовки столбцов таблицы */
table.modern-table thead tr th {
  position: sticky;
  top: 50px; /* отступ от верха */
  background: #ffffff;
  z-index: 5;
}

table.modern-table th,
table.modern-table td {
  border: 1px solid #dee2e6;
  padding: 8px;
  text-align: left;
}

.in-order-label {
  color: #ff4500;
     color: #ff4500;
    font-weight: bold;
    margin-left: 4px;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-size: 12px;
}

.qty-btn, .add-btn {
  margin: 0 4px;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background-color: #fafafa;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: black;
    font-weight: 500;
}

.qty-btn,
.add-btn {
  margin: 0 4px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
    transition: background 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Стили для кнопок увеличения и уменьшения */
.qty-btn-decrease {
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
    font-weight: 600;
}

.bonus {
      background: #e4ffe4;
    margin-left: 6px;
    font-size: 10px;
    border: solid 1px #dee2e6;
    }

    .nobonus {
      background: #ff787838;
    margin-left: 6px;
    font-size: 10px;
    border: solid 1px #00000038;
    }

.qty-btn-increase {
  
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
}

.qty-btn:hover {
  opacity: 0.8;
}

.add-btn {
    background-color: #4CAF50!important;
    background-image: linear-gradient(180deg, #22c993, #20a77f)!important;
    color: #fff;
    width: 67%;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background-color: #fafafa;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: black;
    font-weight: 500;
}

.load-more-btn:hover {
  background-color: #fafafa;
}

.button_quantity {
  display:flex;
  align-items:center;
  justify-content:center;
}

.input-field.clear-btn.empty {
  min-width: 250px;
  min-height: 35px;
}

.btn-close-modal:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    height: 24px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 24px;
}

.btn-close-modal {
  width: 35px;
    height: 35px;
    position: relative;
    border-radius: 6px;
}

.btn-close-modal:hover {
  opacity:.5;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0, 123, 255, 0.3); /* полупрозрачная обводка */
  border-radius: 50%;
  border-top-color: #007bff; /* синяя обводка сверху */
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.load-more-btn {
  display: flex;
    align-items: center;
    justify-content: center;
}

.add-btn:hover {
  opacity:.5;
}


.modern-table tr:hover {
    background-color: #f9fafb;
    cursor: pointer;
}

.qty-btn:hover {
  opacity:.5;
}

td p{
    margin-bottom: 2px;
    font-size: 12px;
    line-height: 14px;
}

td span{
    background: #ffc107;
    padding: 0px 4px;
    font-size: 10px;
    border: solid 1px #c7b0b0;
}

.quantity {
  background: transparent;
    border: 0px;
    font-size: 12px;
}

a {
    color: rgb(0 0 0);
    text-decoration: none;
    display: block;
    font-weight: 700;
}

.property {
    margin-top: 4px;
}

td .property span {
    background: transparent;
    padding: 0px;
    font-size: 12px;
    border: solid 0px #c7b0b0;
    margin: 0px;
}

.property-value {
    font-size: 13px;
    font-weight: 500;
    margin-right: 4px;
}

.property-separator {
    font-size: 13px;
    font-weight: normal;
}


.count {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 10px;
    color: #6c757d;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
}

/* Цветовая индикация количества */
.count-low {
    background-color: #ffebee;
    color: #c62828;
    border: 1px solid #ef9a9a;
}

.count-medium {
    background-color: #fff9e6;
    color: #f57c00;
    border: 1px solid #ffd54f;
}

.count-high {
    background-color: #e8f5e9;
    color: #2e7d32;
    border: 1px solid #81c784;
}

.sortable {
    cursor: pointer;
    user-select: none;
    position: relative;
}

.sortable:hover {
    background-color: #f0f0f0;
}

.sort-arrow {
    display: inline-block;
    margin-left: 5px;
    font-size: 14px;
    font-weight: bold;
}

.sort-arrow-active {
    color: #007bff;
}

.sort-arrow-inactive {
    color: #c0c0c0;
}

.warehouse-item {
  padding: 3px 7px;
  font-size: 11px;
  border: solid 1px #19191921;
  border-radius: 8px;
  margin: 2px;
  display: inline-block;
  transition: all 0.3s ease;
}

.warehouse-item:hover {
  border-color: #19191940;
  background-color: #f0f0f0;
  transition: all 0.2s ease;
}

.blue-text {
  background: #baddba;
  color: #2a4f2afc;
  border-color: #2a4f2a4f;
}

.green-karvata {
  color: #039be5;
  background: #e3f2fd;
  border-color: #76c7ee;
}

.tooltips_blue {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.warehouse-group-toggle {
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
}

.warehouse-group-toggle:hover {
  opacity: 0.8;
  border-color: #19191960;
  transition: all 0.2s ease;
}

.warehouse-group-details {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}


/* Быстрые фильтры */
.quick-filters {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.quick-filter-section {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.quick-filter-title {
  font-size: 12px;
  font-weight: 600;
  color: #495057;
  min-width: 70px;
  white-space: nowrap;
}

.quick-filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.quick-chip {
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  background: #ffffff;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  line-height: 1.2;
}

.quick-chip:hover {
  border-color: #007bff!important;
  background: #f0f7ff!important;
  color: #007bff!important;
}

.quick-chip-active {
  background: #007bff!important;
  color: #ffffff!important;
  border-color: #007bff!important;
}

.quick-chip-active:hover {
  background: #0056b3!important;
  border-color: #0056b3!important;
}

.quick-chip-more {
  background: #e9ecef;
  border-color: #adb5bd;
  padding: 4px 10px;
  font-weight: 500;
  color: #6c757d;
}

.quick-chip-more:hover {
  background: #6c757d;
  color: #ffffff;
  border-color: #6c757d;
}

/* Красный крестик в кнопке "Сбросить" */
.reset-icon {
  color: #dc3545;
  font-weight: bold;
  font-size: 14px;
  margin-right: 4px;
}

.button_reset:hover .reset-icon {
  color: #fff;
}

/* Ячейка цены в модалке: старая сверху, текущая снизу; перебиваем общий td span */
.price-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.price-cell .old-price,
.price-cell .price-current {
  background: transparent !important;
  padding: 0 !important;
  border: none !important;
}
.price-cell .price-current {
  font-size: inherit !important;
}
.price-cell .old-price {
  text-decoration: line-through;
  color: #888;
  font-size: 12px !important;
}

</style>
